const WelcomeText = ({ htmlContent }) => (
    <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
);

export default WelcomeText;